// extracted by mini-css-extract-plugin
export default {"contentWrap":"ImgOnTheLeftAndTextOnRight_contentWrap__K1zVS","imgWrap":"ImgOnTheLeftAndTextOnRight_imgWrap__URsh4","textWrap":"ImgOnTheLeftAndTextOnRight_textWrap__X2n7t"};